(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bz-customizations"] && !Shopify.designMode) return;
  try {
    (() => {
    let header;
    let heroImage;
    let observer;
    let scheduled = false;
    const update = () => {
      scheduled = false;
      if (!header?.isConnected) return;
      const overlay = Boolean(heroImage);
      const scrolled = !overlay || heroImage.getBoundingClientRect().bottom <= header.getBoundingClientRect().bottom;
      header.dataset.bzOverlay = String(overlay);
      document.body.classList.toggle('bz-has-first-hero', overlay);
      header.classList.toggle('bz-scrolled', scrolled);
      const base = header.dataset.bzBaseScheme;
      const after = header.dataset.bzScrollScheme;
      if (base && after) {
        header.classList.remove(base, after);
        header.classList.add(scrolled ? after : base);
      }
      const height = header.getBoundingClientRect().height + 'px';
      document.documentElement.style.setProperty('--bz-header-height', height);
      document.documentElement.style.setProperty('--header-height', height);
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(update);
    };
    const bind = () => {
      observer?.disconnect();
      header = document.querySelector('.bz-customizations .section-header .header-wrapper');
      if (!header) return;
      const first = Array.from(document.querySelector('#MainContent')?.children || [])
        .find(section => section.classList.contains('shopify-section') && section.getClientRects().length && getComputedStyle(section).display !== 'none');
      const hero = first?.querySelector('.bz-hero, slideshow-component, .banner');
      heroImage = null;
      if (header.dataset.bzAutoOverlay === 'true' && hero) {
        const image = hero.querySelector('.bz-hero__media img, .banner__media img');
        if (image) heroImage = image.closest('.bz-hero__media, .banner__media');
      }
      observer = new ResizeObserver(schedule);
      observer.observe(header);
      if (heroImage) observer.observe(heroImage);
      update();
    };
    window.addEventListener('scroll', schedule, { passive:true });
    window.addEventListener('resize', bind, { passive:true });
    window.addEventListener('pageshow', bind);
    document.addEventListener('shopify:section:load', bind);
    document.addEventListener('shopify:section:unload', () => requestAnimationFrame(bind));
    document.addEventListener('shopify:section:reorder', bind);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once:true });
    else bind();
  })();

  (() => {
    const labelFloatifyWhatsApp = () => {
      const link = document.querySelector('a.ot-btn-item[data-type="whatsapp"]');
      if (!link) return false;
      if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', 'Contactar por WhatsApp');
      if (!link.getAttribute('title')) link.setAttribute('title', 'Contactar por WhatsApp');
      return true;
    };
    if (labelFloatifyWhatsApp()) return;
    const floatifyObserver = new MutationObserver(() => {
      if (labelFloatifyWhatsApp()) floatifyObserver.disconnect();
    });
    const startFloatifyObserver = () => floatifyObserver.observe(document.documentElement, { childList: true, subtree: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startFloatifyObserver, { once: true });
    else startFloatifyObserver();
  })();
  } catch(e) { console.error(e); }
})();

})();
